<div class="layout-topbar">
    <a class="layout-topbar-logo" [routerLink]="homeUrl">
        <img ngSrc="assets/logo/ep-logo-inline.png" width="1118" height="226" style="width: auto;" alt="Easypick logo" priority>
    </a>

    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
    </button>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>

    <div #topbarmenu class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <button class="p-link layout-topbar-button" (click)="langMenu.toggle($event)">
            <span class="layout-topbar-flag" aria-hidden="true">{{ currentFlag() }}</span>
            <span>{{ 'SHELL.LANGUAGE' | translate }}</span>
        </button>
        <button class="p-link layout-topbar-button" (click)="switchTheme()">
            <i [ngClass]="layoutService.theme() === 'light' ? 'pi-sun' : 'pi-moon'" class="pi"></i>
            <span>Theme</span>
        </button>
        <button class="p-link layout-topbar-button" [routerLink]="'/documentation'">
            <i class="pi pi-cog"></i>
            <span>Settings</span>
        </button>
        <button class="p-link layout-topbar-button" (click)="menu.toggle($event)">
            <i class="pi pi-user"></i>
            <span>Profile</span>
        </button>
    </div>
</div>

<p-menu #menu [model]="items" [popup]="true" styleClass="w-full md:w-18rem">
    <ng-template pTemplate="start">
        <button pRipple class="relative overflow-hidden w-full p-link flex align-items-center p-2 pl-3 text-color hover:surface-200 border-noround">
            <p-avatar [image]="avatar()" class="mr-3" size="large" shape="circle" />
            <span class="inline-flex flex-column gap-1">
                <span class="font-bold text-lg">
                    {{ userInfoStore.user() | username }}
                </span>
                <span class="text-sm">
                    {{ userInfoStore.profile().phoneNumber }}
                </span>
            </span>
        </button>
    </ng-template>
    <ng-template pTemplate="item" let-item>
        <a pRipple class="flex align-items-center p-menuitem-link">
            <span [class]="item.icon"></span>
            <span class="ml-2">{{ item.label }}</span>
            <p-badge *ngIf="item.badge" class="ml-auto" [value]="item.badge" />
        </a>
    </ng-template>
</p-menu>
<p-menu #langMenu [model]="langItems()" [popup]="true" styleClass="w-full md:w-14rem" />